import React from "react";

const CPP_Syllabus = () => {
  return (
    <div>
      <h1>CPP_Syllabus Component</h1>
      <p>Content for CPP_Syllabus goes here...</p>
    </div>
  );
};

export default CPP_Syllabus;
